import ApiService from "../../core/service/api-service";
import FileHelper from "../../core/utils/file-helper";

// Dosya adı: şablon adı okunur kalsın ama dosya sisteminde sorun çıkarmasın.
const slugify = (text) => (text ?? '')
    .toString()
    .trim()
    .toLocaleLowerCase('tr')
    .replace(/[ıî]/g, 'i')
    .replace(/[şŝ]/g, 's')
    .replace(/[ğĝ]/g, 'g')
    .replace(/[üû]/g, 'u')
    .replace(/[öô]/g, 'o')
    .replace(/[çĉ]/g, 'c')
    .replace(/â/g, 'a')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

/**
 * Şablonu JSON dosyası olarak indirir.
 *
 * İçerik (Teknik/Bulgular/Sonuç...) sunucuda zaten JSON dosyasında tutuluyor; burada
 * yalnızca içeriği değil, şablonu tanımlayan bilgileri de (istem tipi, modalite, dil...)
 * ekliyoruz: dosya tek başına anlamlı olsun ve ileride içe aktarma yazılabilsin.
 *
 * @param {{row: object}} params row: grid satırı (ad/istem tipi/modalite burada zaten var)
 * @returns {Promise<boolean>} indirme başarılıysa true
 */
export default async function downloadReportTemplateJson({row})
{
    const res = await ApiService.ReportTemplate.GetReportTemplateFileData(row.id)

    if (!res?.success)
        return false

    // Sunucu içeriği JSON string olarak döndürür. Bozuksa indirmeyi iptal etmek yerine
    // ham metni koruyoruz; kullanıcı en azından elindeki veriyi kaybetmesin.
    let content
    try {
        content = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
    } catch {
        content = res.data ?? null
    }

    const template = {
        exportVersion: 1,
        exportedAt: new Date().toISOString(),
        type: 'report-template',
        id: row.id,
        name: row.name,
        language: row.language ?? null,
        studyType: row.studyType ?? null,
        requestType: row.requestType
            ? {
                id: row.requestType.id,
                name: row.requestType.name,
                sutCode: row.requestType.sutCode ?? null,
                loincCode: row.requestType.loincCode ?? null
            }
            : null,
        modality: row.requestType?.modality
            ? {
                id: row.requestType.modality.id,
                name: row.requestType.modality.name
            }
            : null,
        owner: row.belongUser
            ? {
                id: row.belongUser.id,
                username: row.belongUser.username,
                name: row.belongUser.name
            }
            : null,
        content
    }

    const blob = new Blob([JSON.stringify(template, null, 2)], {type: 'application/json'})
    const blobLink = URL.createObjectURL(blob)

    try {
        FileHelper.saveFile({
            blobLink,
            fileName: `${slugify(row.name) || 'report-template'}-${row.id}.json`
        })
    } finally {
        // Tarayıcı indirmeyi başlattıktan sonra URL'i bırak; hemen revoke edilirse
        // bazı tarayıcılarda indirme yarıda kesiliyor.
        setTimeout(() => URL.revokeObjectURL(blobLink), 10000)
    }

    return true
}
